import React, { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import { instance2 } from "../../utils/axiosInstance";

export default function InputLocation() {
  const [formData, setFormData] = useState({
    name: "",
    location_id: "",
    description: "",
    admin_id: "",
    district_id: "",
    village_id: "",
  });
 console.log("formdata", formData)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [location, setLocation] = useState([]); // Storage locations
  const [district, setDistrict] = useState([]); // Storage locations
  const [village, setVillage] = useState([]); // Storage locations
  const [loading, setLoading] = useState(true); // Loading state
  const [user, setUser] = useState("");
  const [searchRegTerm, setSearchRegTerm] = useState("");
  const [searchDistTerm, setSearchDistTerm] = useState("");
  const [searchVillTerm, setSearchVillTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDistrictOpen, setIsDistrictOpen] = useState(false);
  const [isVillageOpen, setIsVillageOpen] = useState(false);

  const dropdownRef = useRef(null); // Ref for detecting outside clicks


  useEffect(() => {
    const storedUser = localStorage.getItem('userAuthentication');
    if (storedUser) {
      setUser(storedUser);
    }
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage("");
  
    try {
      // Use instance2 for the API call
      const response = await instance2.post("location", formData);
  
      // Handle successful response
      //setSuccessMessage("Location created successfully!");
      toast.success("Lokasi Baru Berhasil Ditambahkan");
      setFormData({
        name: "",
        location_id: "",
        description: "",
        admin_id: userId, // Reset admin_id to current user
      });
      window.history.back();
    } catch (err) {
      // Handle errors
      setError(err.response?.data?.message || "Gagal Menambahkan Lokasi. Mohon Coba Lagi.");
      console.error("Error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };
  

  useEffect(() => {
    
    const fetchLocation = async () => {
      try {
        const response = await instance2.get("regency"); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setLocation(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch cities", err);
        setError(err.response?.data?.message || "Failed to fetch storage cities");
      } finally {
        setLoading(false);
      }
    };
  
    fetchLocation();
  }, []);
  

  const filteredLocations = location.filter((loc) =>
    loc.name.toLowerCase().includes(searchRegTerm.toLowerCase())
  );


  useEffect(() => {
    if(formData.district_id){
    const fetchVillage = async () => {
      try {
        const response = await instance2.get(`villages/district/${formData.district_id}`); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setVillage(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch villages", err);
        setError(err.response?.data?.message || "Failed to fetch storage villages");
      } finally {
        setLoading(false);
      }
    };
  
    fetchVillage();
  }
  }, [formData.district_id]);
  

  const filteredVillage = village.filter((loc) =>
    loc.name.toLowerCase().includes(searchVillTerm.toLowerCase())
  );


  useEffect(() => {
    
    if(formData.location_id){
      const fetchDistrict = async () => {
      if (formData.location_id) {
      try {
        const response = await instance2.get(`districts/regency/${formData.location_id}`); // Use instance2 for the API call
  
        const districtData = response.data; // Access the data property from Axios response
  
        setDistrict(
          districtData.map((loc) => ({
            id: loc.id,
            name: loc.name,
            code: loc.code,
          }))

        );

      } catch (err) {
        console.error("Failed to fetch districts", err);
        setError(err.response?.data?.message || "Failed to fetch storage districts");
      } finally {
        setLoading(false);
      }
    };
  
  }
  
  fetchDistrict();
}
  }, [formData.location_id]);
  

  const filteredDistrict = district.filter((loc) =>
    loc.name.toLowerCase().includes(searchDistTerm.toLowerCase())
  );

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="max-w-md mx-auto">
    <h2 className="text-lg font-bold mb-4">Tambah Data Koperasi</h2>
    <form onSubmit={handleSubmit}>
      {/* Name */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Nama Koperasi</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Nama Koperasi"
          required
        />
      </div>

      {loading ? (
        <p>Loading...</p>
      ) :  (
        <>
          {/* Location ID */}
          <div className="mb-4 relative">
      <label className="block text-gray-700 mb-2">Kota/Kabupaten</label>
      <div className="relative">
        <input
          type="text"
          placeholder="Pilih Kota/Kabupaten"
          value={searchRegTerm}
          onChange={(e) => {
            setSearchRegTerm(e.target.value);
            console.log("Updated searchRegTerm onChange:", e.target.value); // Log here to see the change
          }}
          onFocus={() => setIsDropdownOpen(true)} // Show dropdown on focus
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
        />
        {/* Dropdown Arrow */}
        <div
          className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
          onClick={() => setIsDropdownOpen((prev) => !prev)} // Toggle dropdown visibility
        >
          <svg
            className={`w-4 h-4 transition-transform ${
              isDropdownOpen ? "rotate-180" : "rotate-0"
            }`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>

      {isDropdownOpen && (
        <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
          {filteredLocations.length > 0 ? (
            filteredLocations.map((loc) => (
              <div
              key={loc.id}
              className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
              onMouseDown={() => {
                // Log the selected location
                console.log("Selected location:", loc.name);
                
                // Update form data with selected location ID
                setFormData({ ...formData, location_id: loc.id });
          
                // Set the searchRegTerm to the selected location name
                setSearchRegTerm(loc.name);
          
                // Close the dropdown after selection
                setIsDropdownOpen(false);
              }}
            >
              {loc.name}
            </div>
            ))
          ) : (
            <div className="px-4 py-2 text-sm text-gray-500">
              No locations found
            </div>
          )}
        </div>
      )}
    </div>  
                    {/* District ID */}
                    <div className="mb-4 relative" ref={dropdownRef}>
                      <label className="block text-gray-700 mb-2">Kecamatan</label>
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Pilih Kota/Kabupaten"
                          value={searchDistTerm}
                          onChange={(e) => setSearchDistTerm(e.target.value)}
                          onFocus={() => setIsDistrictOpen(true)}
                          className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
                        />
                        {/* Dropdown Arrow */}
                        <div
                          className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                          onClick={() => setIsDistrictOpen((prev) => !prev)}
                        >
                          <svg
                            className={`w-4 h-4 transition-transform ${
                              isDistrictOpen ? "rotate-180" : "rotate-0"
                            }`}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                      {isDistrictOpen && (
                                    <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                                      {filteredDistrict.length > 0 ? (
                                        filteredDistrict.map((loc) => (
                                          <div
                                            key={loc.id}
                                            className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                            onClick={() => {
                                              setFormData({ ...formData, district_id: loc.code });
                                              setSearchDistTerm(loc.name);
                                              setIsDistrictOpen(false);
                                            }}
                                          >
                                            {loc.name}
                                          </div>
                                        ))
                                      ) : (
                                        <div className="px-4 py-2 text-sm text-gray-500">
                                          No district found
                                        </div>
                                      )}
                                    </div>
                                  )}  
                                  

</div>            
                    {/* Village ID */}
                    <div className="mb-4 relative" ref={dropdownRef}>
                      <label className="block text-gray-700 mb-2">Kelurahan</label>
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Pilih Kelurahan/Desa"
                          value={searchVillTerm}
                          onChange={(e) => setSearchVillTerm(e.target.value)}
                          onFocus={() => setIsVillageOpen(true)}
                          className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
                        />
                        {/* Dropdown Arrow */}
                        <div
                          className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                          onClick={() => setIsVillageOpen((prev) => !prev)}
                        >
                          <svg
                            className={`w-4 h-4 transition-transform ${
                              isVillageOpen ? "rotate-180" : "rotate-0"
                            }`}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>

                        {isVillageOpen && (
                                      <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                                        {filteredVillage.length > 0 ? (
                                          filteredVillage.map((loc) => (
                                            <div
                                              key={loc.code}
                                              className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                              onClick={() => {
                                                setFormData({ ...formData, village_id: loc.code });
                                                console.log("form",formData.village_id)
                                                setSearchVillTerm(loc.name);
                                                setIsVillageOpen(false);
                                              }}
                                            >
                                              {loc.name}
                                            </div>
                                          ))
                                        ) : (
                                          <div className="px-4 py-2 text-sm text-gray-500">
                                            No village found
                                          </div>
                                        )}
                                      </div>
                                    )}  
                                    
                  </div>
                      </>
      )}

      {/* Description */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Deskripsi</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Deskripsi"
          required
        ></textarea>
      </div>

      {/* Admin ID */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Admin ID</label>
        <input
          type="text"
          name="admin_id"
          value={user} // Replace with dynamic user ID if needed
          className="w-full px-3 border-none rounded-full bg-gray-200 text-xs py-4"
          placeholder="Admin ID"
          disabled // Ensure the field is read-only
        />
      </div>

      {/* Submit Button */}
      <div className="flex justify-end">
        <button
          type="submit"
          className={`px-4 py-2 bg-merah-no text-white rounded hover:bg-merah-hover ${
            isSubmitting || !formData.village_id && "opacity-50 cursor-not-allowed"
          }`}
          disabled={isSubmitting || !formData.village_id}

        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </div>
    </form>

    {/* Success Message */}
    {successMessage && <p className="text-green-500 mt-4">{successMessage}</p>}

    {/* Error Message */}
    {error && <p className="text-red-500 mt-4">{error}</p>}
  </div>
  );
}
